// extracted by mini-css-extract-plugin
export default {"details-card":"PhotoDetails_details-card__XARIf","details-image":"PhotoDetails_details-image__MZ1MR","title":"PhotoDetails_title__iUr4r","subtitle":"PhotoDetails_subtitle__hn5Tz"};